import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UiService {
    #http = inject(HttpClient);

    store = new Map<string, string>();

    getControlValue(key: string): string {
        return this.store.get(key);
    }

    setControlValue(key: string, value: any) {
        this.store.set(key, value.toString());
    }

    getVersion(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.#http.get('/assets/version.txt', { responseType: 'text' }).subscribe({
                next: (res) => resolve(res),
                error: (err) => reject(err),
            });
        });
    }

    setTitle(title: string, siteName?: string) {
        let pageTitle: string = '';
        if (siteName) {
            pageTitle = 'Your IT Portal - ' + title + ' - ' + siteName;
        } else {
            pageTitle = 'Your IT Portal - ' + title;
        }
        document.title = pageTitle;
    }
}
